import { render, staticRenderFns } from "./StarItemIcon.vue?vue&type=template&id=7bea5411&scoped=true"
import script from "./StarItemIcon.vue?vue&type=script&lang=js"
export * from "./StarItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea5411",
  null
  
)

export default component.exports